import { render, staticRenderFns } from "./SmsTextInputWings.vue?vue&type=template&id=54c22ff9&"
import script from "./SmsTextInputWings.vue?vue&type=script&lang=ts&"
export * from "./SmsTextInputWings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports